
    var riot = require('riot')
    //src: starling/src/tags/dummy-input.html
riot.tag2('dummy-input',
  '<input ref="input" type="text" class="dummy-input mousetrap" onpaste="{this.canvas.handlePaste}" oninput="{handleDummyInput}">',
  'dummy-input .dummy-input,[data-is="dummy-input"] .dummy-input{ height: 0px; width: 0px; position: absolute; top: 0px; left: 0px; padding: 0px; margin: 0px; opacity: 0; }',
  '', function(opts) {
'use strict';

var _this = this;

/*
Dummy input field - currently used to trick firefox into thinking we have focus on a text input when we've selected a card, so that we can get Firefox to paste images into cards.
*/
this.canvas = this.parent;
this.canvas.dummyInputTag = this;

this.handleDummyInput = function (e) {
  if (!e.ctrlKey || !e.metaKey) {
    e.preventDefault();
  }
  _this.refs.input.value = '';
};
this.focus = function () {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  _this.refs.input.focus();
};
this.defocus = function () {
  var $focused = $(':focus');
  $focused.blur();
  window.getSelection().removeAllRanges();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('dummy-input')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/dummy-input.html
// module id = 589
// module chunks = 0